import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index.vue'
import Company from '../components/Company.vue'
import Media from "../components/Media.vue"
import Product from '../components/Product.vue'
import Share from '../components/Share.vue'
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index
    },
    {
      path: '/index',
      component: Index
    },
    {
      path: '/company',
      component: Company,
    },
    {
      path: '/product',
      component: Product
    },
    {
      path: '/zx',
      component: Media
    },
    {
      path: '/bl',
      component: Share
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js